import { PipeTransform, Pipe, Injectable } from '@angular/core';
import { ActorRoleDutyController } from '../../models/master/mastermodel';


@Pipe({
  name: 'ActorRoleDutyFilter'
})

@Injectable()
export class ActorRoleDutyPipe implements PipeTransform {

  transform(value: ActorRoleDutyController[], filter: string): ActorRoleDutyController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: ActorRoleDutyController) =>
      app.ActorTypeName != null && app.ActorTypeName.toLocaleLowerCase().indexOf(filter) != -1

      || app.Duty != null && app.Duty.toLocaleLowerCase().indexOf(filter) != -1
      || app.Role != null && app.Role.toLocaleLowerCase().indexOf(filter) != -1
      || app.RoleLongValue != null && app.RoleLongValue.toLocaleLowerCase().indexOf(filter) != -1

    ) : value;
  }

}
